import { validate } from 'uuid';

export function valid__tournamentID(value: string): boolean {
    return value && validate(value) ? true : false
}